import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const MuiTripleLabelWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  .label-style {
    white-space: nowrap;
    line-height: 22px;
    color: ${COLORS.cirrus_black};
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .sub-value-style {
    margin-top: 8px;
    color: ${COLORS.cirrus_black8};
  }

  .value-style {
    color: ${COLORS.cirrus_black};
    line-height: 20px;
  }
`;
